import gql from 'graphql-tag'

export default gql`
	fragment CashBookFragment on CashBook {
		id
		billNumber
		dateTime
		linkCashRegister
		userId
		description
		should
		have
		balance
		taxCode
		shouldAccount
		haveAccount
	}
`
